
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-table_view",
  "use": "icon-material-table_view-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-table_view\"><path d=\"M345.02-111.15q-28.1 0-48.12-20.09-20.01-20.08-20.01-48.28v-435.46q0-28.2 20.01-48.28 20.02-20.09 48.12-20.09h435.46q28.2 0 48.28 20.09 20.09 20.08 20.09 48.28v435.46q0 28.2-20.09 48.28-20.08 20.09-48.28 20.09zm0-399.5h435.46v-104.33H345.02zm164.33 166.56h106.8v-106.56h-106.8zm0 164.57h106.8v-104.57h-106.8zM345.02-344.09h104.33v-106.56H345.02zm331.13 0h104.33v-106.56H676.15zM345.02-179.52h104.33v-104.57H345.02zm331.13 0h104.33v-104.57H676.15zm-496.63-97.37q-28.2 0-48.28-20.01-20.09-20.02-20.09-48.12v-435.46q0-28.2 20.09-48.28 20.08-20.09 48.28-20.09h435.46q28.2 0 48.28 20.09 20.09 20.08 20.09 48.28v67.13h-68.37v-67.13H179.52v435.46h67.37v68.13z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-table_view"/>
                </svg>
            );
        };

        Icon.id = "icon-material-table_view";

        export default Icon;
    